@if (companyName) {
  <mat-list-item class="py-2 bg-lightest">
    <div  class="w-100 fx-row fx-gap-sm y-center" [class.x-center]="!isExpanded">
      <mat-icon class="size-34 material-icons-outlined" matTooltipPosition="right" [matTooltip]="'Company: ' + companyName" [matTooltipDisabled]="isExpanded">domain</mat-icon>
      @if (isExpanded) {
        <div>
          <div class="company-name mat-body-2 text-bold text-uppercase line-height-0" id="company-info">{{companyName}}</div>
          <div class="company-label mat-caption line-height-0">Company Name</div>
        </div>
      }
    </div>
  </mat-list-item>
}
